export default "__VITE_ASSET__1duK02iA__"